const runtimeConfig = window.__APP_CONFIG__ || {};

const buildConfig = {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL || '',
  storageUrl: process.env.VUE_APP_STORAGE_URL || '',
  echoPort: process.env.VUE_APP_ECHO_PORT || '',
  aisApiUrl: process.env.VUE_APP_AIS_API || '',
  googleMapsKey: process.env.VUE_APP_GOOGLE_MAPS_KEY || '',
  docusignClientIntegrationId:
    process.env.VUE_APP_DS_CLIENT_INTEGRATION_ID || ''
};

function getRuntimeValue(...keys) {
  for (const key of keys) {
    const value = runtimeConfig[key];

    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
  }

  return '';
}

export default {
  apiBaseUrl: getRuntimeValue('VUE_APP_API_BASE_URL') || buildConfig.apiBaseUrl,
  storageUrl: getRuntimeValue('VUE_APP_STORAGE_URL') || buildConfig.storageUrl,
  echoPort: getRuntimeValue('VUE_APP_ECHO_PORT') || buildConfig.echoPort,
  aisApiUrl: getRuntimeValue('VUE_APP_AIS_API') || buildConfig.aisApiUrl,
  googleMapsKey:
    getRuntimeValue('VUE_APP_GOOGLE_MAPS_KEY') || buildConfig.googleMapsKey,
  docusignClientIntegrationId:
    getRuntimeValue(
      'VUE_APP_DS_CLIENT_INTEGRATION_ID',
      'DS_CLIENT_INTEGRATION_ID'
    ) || buildConfig.docusignClientIntegrationId
};
